// extracted by mini-css-extract-plugin
export default {"newOrderButton":"newOrderButton__3cgu5"};
    if(module.hot) {
      // 1764953330233
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  